export const setMeta = (attr, key, content) => {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
};

export const setCanonical = (href) => {
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) { link = document.createElement("link"); link.setAttribute("rel", "canonical"); document.head.appendChild(link); }
  link.setAttribute("href", href);
};

export const injectLd = (key, objects) => {
  clearLd(key);
  objects.forEach((obj) => {
    const s = document.createElement("script");
    s.type = "application/ld+json";
    s.dataset.seo = key;
    s.textContent = JSON.stringify(obj);
    document.head.appendChild(s);
  });
};

export const clearLd = (key) => document.querySelectorAll(`script[data-seo="${key}"]`).forEach((s) => s.remove());
